// extracted by mini-css-extract-plugin
export default {"card":"BackgroundForm_card__+K0-A","content":"BackgroundForm_content__3yzJX"};